"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rounds = exports.RoundsContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.RoundsContainer = styled_components_1.default.div `
  ${style_1.default.Text.Definition.Footer};
  border-radius: 50%;
  display: flex;
  height: ${style_1.default.Sizing.Size.Tiny};
  width: ${style_1.default.Sizing.Size.Tiny};
  align-items: center;
  justify-content: center;
  border: 1px solid ${style_1.default.Color.Gray.S200};
  padding: ${style_1.default.Layout.Spacing.Tiny};
  font-size: ${style_1.default.Text.Size.Tiny};
  color: ${props => props.theme.Color.Text.Secondary};
`;
const Rounds = ({ rounds, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.RoundsContainer, { children: rounds }));
};
exports.Rounds = Rounds;
